function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["analyticsName", "trackImpression", "headingStyle", "as", "Component"],
  _excluded2 = ["as", "analyticsName"];
function cov_nvx2l5u8j() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Heading/Heading.tsx";
  var hash = "501e3d5051cbcdb6b76fdc06943a6e278d75b840";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Heading/Heading.tsx",
    statementMap: {
      "0": {
        start: {
          line: 44,
          column: 28
        },
        end: {
          line: 60,
          column: 2
        }
      },
      "1": {
        start: {
          line: 51,
          column: 20
        },
        end: {
          line: 51,
          column: 92
        }
      },
      "2": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 59,
          column: 4
        }
      },
      "3": {
        start: {
          line: 187,
          column: 23
        },
        end: {
          line: 215,
          column: 2
        }
      },
      "4": {
        start: {
          line: 188,
          column: 15
        },
        end: {
          line: 188,
          column: 55
        }
      },
      "5": {
        start: {
          line: 189,
          column: 17
        },
        end: {
          line: 189,
          column: 64
        }
      },
      "6": {
        start: {
          line: 190,
          column: 16
        },
        end: {
          line: 190,
          column: 73
        }
      },
      "7": {
        start: {
          line: 191,
          column: 27
        },
        end: {
          line: 191,
          column: 66
        }
      },
      "8": {
        start: {
          line: 191,
          column: 41
        },
        end: {
          line: 191,
          column: 55
        }
      },
      "9": {
        start: {
          line: 194,
          column: 2
        },
        end: {
          line: 205,
          column: 3
        }
      },
      "10": {
        start: {
          line: 195,
          column: 4
        },
        end: {
          line: 204,
          column: 6
        }
      },
      "11": {
        start: {
          line: 207,
          column: 2
        },
        end: {
          line: 214,
          column: 4
        }
      },
      "12": {
        start: {
          line: 223,
          column: 51
        },
        end: {
          line: 225,
          column: 1
        }
      },
      "13": {
        start: {
          line: 224,
          column: 2
        },
        end: {
          line: 224,
          column: 49
        }
      },
      "14": {
        start: {
          line: 226,
          column: 51
        },
        end: {
          line: 228,
          column: 1
        }
      },
      "15": {
        start: {
          line: 227,
          column: 2
        },
        end: {
          line: 227,
          column: 49
        }
      },
      "16": {
        start: {
          line: 229,
          column: 51
        },
        end: {
          line: 231,
          column: 1
        }
      },
      "17": {
        start: {
          line: 230,
          column: 2
        },
        end: {
          line: 230,
          column: 49
        }
      },
      "18": {
        start: {
          line: 232,
          column: 51
        },
        end: {
          line: 234,
          column: 1
        }
      },
      "19": {
        start: {
          line: 233,
          column: 2
        },
        end: {
          line: 233,
          column: 49
        }
      },
      "20": {
        start: {
          line: 235,
          column: 51
        },
        end: {
          line: 237,
          column: 1
        }
      },
      "21": {
        start: {
          line: 236,
          column: 2
        },
        end: {
          line: 236,
          column: 49
        }
      },
      "22": {
        start: {
          line: 238,
          column: 51
        },
        end: {
          line: 240,
          column: 1
        }
      },
      "23": {
        start: {
          line: 239,
          column: 2
        },
        end: {
          line: 239,
          column: 49
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 86
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 50
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 187,
            column: 54
          },
          end: {
            line: 187,
            column: 55
          }
        },
        loc: {
          start: {
            line: 187,
            column: 96
          },
          end: {
            line: 215,
            column: 1
          }
        },
        line: 187
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 191,
            column: 35
          },
          end: {
            line: 191,
            column: 36
          }
        },
        loc: {
          start: {
            line: 191,
            column: 41
          },
          end: {
            line: 191,
            column: 55
          }
        },
        line: 191
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 223,
            column: 51
          },
          end: {
            line: 223,
            column: 52
          }
        },
        loc: {
          start: {
            line: 224,
            column: 2
          },
          end: {
            line: 224,
            column: 49
          }
        },
        line: 224
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 226,
            column: 51
          },
          end: {
            line: 226,
            column: 52
          }
        },
        loc: {
          start: {
            line: 227,
            column: 2
          },
          end: {
            line: 227,
            column: 49
          }
        },
        line: 227
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 229,
            column: 51
          },
          end: {
            line: 229,
            column: 52
          }
        },
        loc: {
          start: {
            line: 230,
            column: 2
          },
          end: {
            line: 230,
            column: 49
          }
        },
        line: 230
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 232,
            column: 51
          },
          end: {
            line: 232,
            column: 52
          }
        },
        loc: {
          start: {
            line: 233,
            column: 2
          },
          end: {
            line: 233,
            column: 49
          }
        },
        line: 233
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 235,
            column: 51
          },
          end: {
            line: 235,
            column: 52
          }
        },
        loc: {
          start: {
            line: 236,
            column: 2
          },
          end: {
            line: 236,
            column: 49
          }
        },
        line: 236
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 238,
            column: 51
          },
          end: {
            line: 238,
            column: 52
          }
        },
        loc: {
          start: {
            line: 239,
            column: 2
          },
          end: {
            line: 239,
            column: 49
          }
        },
        line: 239
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 188,
            column: 15
          },
          end: {
            line: 188,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 188,
            column: 33
          },
          end: {
            line: 188,
            column: 43
          }
        }, {
          start: {
            line: 188,
            column: 46
          },
          end: {
            line: 188,
            column: 55
          }
        }],
        line: 188
      },
      "1": {
        loc: {
          start: {
            line: 189,
            column: 18
          },
          end: {
            line: 189,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 189,
            column: 18
          },
          end: {
            line: 189,
            column: 20
          }
        }, {
          start: {
            line: 189,
            column: 25
          },
          end: {
            line: 189,
            column: 40
          }
        }],
        line: 189
      },
      "2": {
        loc: {
          start: {
            line: 190,
            column: 50
          },
          end: {
            line: 190,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 190,
            column: 50
          },
          end: {
            line: 190,
            column: 54
          }
        }, {
          start: {
            line: 190,
            column: 58
          },
          end: {
            line: 190,
            column: 60
          }
        }],
        line: 190
      },
      "3": {
        loc: {
          start: {
            line: 194,
            column: 2
          },
          end: {
            line: 205,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 194,
            column: 2
          },
          end: {
            line: 205,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 194
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "501e3d5051cbcdb6b76fdc06943a6e278d75b840"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_nvx2l5u8j = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_nvx2l5u8j();
import "core-js/modules/es.array.concat.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable jsx-a11y/heading-has-content */
import React, { useMemo } from 'react';
import { useMergeRefs } from '@chakra-ui/hooks';
import { forwardRef } from '@chakra-ui/system';
import { useTrackComponentInView } from "../../hooks/useObservabilitySafe.mjs";
import { bricks } from "../../system/bricks.types.mjs";
import { useStyleConfig } from "../../system/utils/index.mjs";

/** bricks.opendoor.com/?path=/docs/core-heading */

var HeadingWithTracking = (cov_nvx2l5u8j().s[0]++, forwardRef(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    headingStyle = _ref.headingStyle,
    as = _ref.as,
    Component = _ref.Component,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_nvx2l5u8j().f[0]++;
  var inViewRef = (cov_nvx2l5u8j().s[1]++, useTrackComponentInView('textViewEvent', trackImpression, analyticsName));
  cov_nvx2l5u8j().s[2]++;
  return /*#__PURE__*/React.createElement(Component
  // __css has a lower priority than sx
  , _extends({
    __css: headingStyle,
    ref: useMergeRefs(inViewRef, ref)
  }, props));
}));

/**
 * Heading composes a Box component and supports all the same style props.
 * Heading should be used for rendering html heading elements.
 *
 * It renders an h1 by default, but the heading level that is rendered can be
 * controlled using the optional size prop. The bricks design system theme only
 * supports h1-h4. Please use non-standard font/line-height sizes with caution
 * only if designers agree if a size exception is absolutely warranted as this
 * component intentionally overrides the design system standards
 *
 * Heading Variations
 *
 *
 * ----------------------
 *
 * It renders an `h1` by default, but the heading level that is rendered can be
 * controlled using the optional `level` prop, which accepts integers 1 - 4
 * since the Bricks design system theme only supports `h1` - `h4`.
 *
 * ###
 *
 * Shorthand components
 *
 * Shorthand components `H1`, `H2`, `H3`, and `H4` can be used to render a
 * `Heading` at levels 1, 2, 3 and 4 respectively.
 *
 * ###
 *
 * Heading Sizes
 *
 * The size options range from the very smallest (`80`) to the largest (`260`).
 * Consumers of the design system should never have to explicitly specify the
 * tokens or pixel values for `fontSize`, `lineHeight`, and other type styles.
 * Instead, by using the `size` prop on the typography components, type styles
 * will not only be standardized but also responsive as specified by design
 * standards.
 *
 * The size prop is not responsive but rather handles any responsive font sizes
 * under the hood. For example, size 210 is equal to `48px` on desktop and
 * tablet but `40px` on mobile.
 *
 * Heading size variations
 * ---------------------------------------------------------------------------------------------------
 *
 * "80"
 *
 * "90"
 *
 * "100"
 *
 * "110"
 *
 * "120"
 *
 * "130"
 *
 * "140"
 *
 * "150"
 *
 * "160"
 *
 * "170"
 *
 * "180"
 *
 * "190"
 *
 * "200"
 *
 * "210"
 *
 * "220"
 *
 * "230"
 *
 * "240"
 *
 * "250"
 *
 * "260"
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * Header tags (h1, h2, etc.) are required when appropriate. It is possible,
 * using CSS, to style text as large, bold text to make it look like a heading,
 * but this visual information is not conveyed to screen reader users.**The
 * semantic meaning of a heading HTML element is critical to convey the
 * programmatic meaning to assistive technology and to its users, who may not be
 * able to see the large, bold text.**
 *
 * ###
 *
 * ✅ Pass
 *
 * <Heading size="h2">Title</Heading>
 *
 *
 * ###
 *
 * 🛑 Fail
 *
 * <Text fontSize="s5" fontWeight="bold"> Title </Text>
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Heading` is set up to track impression events:
 *
 * To track impression events in the heading pass: 1) a non-empty
 * `analyticsName` 2) pass `trackImpression={true}` Heading impression events
 * will only be tracked the first time that the heading enters the viewport.
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_heading\_view\_event for heading
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
export var Heading = (cov_nvx2l5u8j().s[3]++, forwardRef(function (_ref2, ref) {
  var _ref3, _ref4;
  var as = _ref2.as,
    analyticsName = _ref2.analyticsName,
    props = _objectWithoutProperties(_ref2, _excluded2);
  cov_nvx2l5u8j().f[1]++;
  var size = (cov_nvx2l5u8j().s[4]++, 'size' in props ? (cov_nvx2l5u8j().b[0][0]++, props.size) : (cov_nvx2l5u8j().b[0][1]++, undefined));
  var asProp = (cov_nvx2l5u8j().s[5]++, (_ref3 = (cov_nvx2l5u8j().b[1][0]++, as)) !== null && _ref3 !== void 0 ? _ref3 : (cov_nvx2l5u8j().b[1][1]++, size));
  var style = (cov_nvx2l5u8j().s[6]++, useStyleConfig('Heading', _objectSpread({
    size: (_ref4 = (cov_nvx2l5u8j().b[2][0]++, size)) !== null && _ref4 !== void 0 ? _ref4 : (cov_nvx2l5u8j().b[2][1]++, as)
  }, props)));
  var HeadingComponent = (cov_nvx2l5u8j().s[7]++, useMemo(function () {
    cov_nvx2l5u8j().f[2]++;
    cov_nvx2l5u8j().s[8]++;
    return bricks(asProp);
  }, [asProp]));

  // Now that HeadingComponent is memoized this distinction shouldn't be necessary anymore
  cov_nvx2l5u8j().s[9]++;
  if (analyticsName) {
    cov_nvx2l5u8j().b[3][0]++;
    cov_nvx2l5u8j().s[10]++;
    return /*#__PURE__*/React.createElement(HeadingWithTracking, _extends({
      as: asProp,
      ref: ref,
      headingStyle: style,
      analyticsName: "".concat(analyticsName, "-").concat(asProp),
      Component: HeadingComponent
    }, props));
  } else {
    cov_nvx2l5u8j().b[3][1]++;
  }
  cov_nvx2l5u8j().s[11]++;
  return /*#__PURE__*/React.createElement(HeadingComponent
  // __css has a lower priority than sx
  , _extends({
    __css: style,
    ref: ref
  }, props));
}));

////////////////////////////////////////////////////////////////////////////////
// Shorthand aliases for the different heading levels.
////////////////////////////////////////////////////////////////////////////////
cov_nvx2l5u8j().s[12]++;
export var H1 = function H1(props) {
  cov_nvx2l5u8j().f[3]++;
  cov_nvx2l5u8j().s[13]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "UNSAFE_h1",
    as: "h1"
  }, props));
};
cov_nvx2l5u8j().s[14]++;
export var H2 = function H2(props) {
  cov_nvx2l5u8j().f[4]++;
  cov_nvx2l5u8j().s[15]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "UNSAFE_h2",
    as: "h2"
  }, props));
};
cov_nvx2l5u8j().s[16]++;
export var H3 = function H3(props) {
  cov_nvx2l5u8j().f[5]++;
  cov_nvx2l5u8j().s[17]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "UNSAFE_h3",
    as: "h3"
  }, props));
};
cov_nvx2l5u8j().s[18]++;
export var H4 = function H4(props) {
  cov_nvx2l5u8j().f[6]++;
  cov_nvx2l5u8j().s[19]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "UNSAFE_h4",
    as: "h4"
  }, props));
};
cov_nvx2l5u8j().s[20]++;
export var H5 = function H5(props) {
  cov_nvx2l5u8j().f[7]++;
  cov_nvx2l5u8j().s[21]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "UNSAFE_h5",
    as: "h5"
  }, props));
};
cov_nvx2l5u8j().s[22]++;
export var H6 = function H6(props) {
  cov_nvx2l5u8j().f[8]++;
  cov_nvx2l5u8j().s[23]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "UNSAFE_h6",
    as: "h6"
  }, props));
};
export default Heading;